// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/mlops/deployer/v2/deployment_status.proto (package ai.h2o.mlops.deployer.v2, syntax proto3)
/* eslint-disable */

import { getNameParser } from "../../../../../runtime";

/**
 * Represents the status of a deployment in an environment.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.DeploymentStatus
 */
export type DeploymentStatus = {
/**
 * Resource name.
 *
 * @generated from field: string name = 1;
 */
name?: string;
/**
 * The current state.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.DeploymentStatus.DeploymentState state = 2;
 */
state?: DeploymentStatus_DeploymentState;
/**
 * Miscellaneous status message.
 *
 * @generated from field: string message = 3;
 */
message?: string;
/**
 * Time of the last status change.
 *
 * @generated from field: google.protobuf.Timestamp update_time = 4;
 */
updateTime?: string;
/**
 * Indicates whether updates are allowed in the current state.
 * If false, update requests will return 409 Conflict.
 *
 * @generated from field: bool updates_allowed = 5;
 */
updatesAllowed?: boolean;
/**
 * Indicates whether config changes were made while the deployment was paused.
 * When true, resuming the deployment will apply the pending config changes.
 *
 * @generated from field: bool config_pending = 6;
 */
configPending?: boolean;
}
;
/**
 * Possible progression of states (public API states):
 *
 * Normal deployment flow:
 *   PENDING -> PREPARING -> LAUNCHING -> DEPLOYED -> (HEALTHY | STOPPED | UNHEALTHY)
 *
 * Failure and retry:
 *   PREPARING | LAUNCHING | DEPLOYED -> FAILED
 *   FAILED -> FAILED (internal REDEPLOYING cleanup) -> PENDING (retry)
 *
 * Runtime state changes (monitored from K8s):
 *   HEALTHY <-> UNHEALTHY
 *   (HEALTHY | UNHEALTHY) -> STOPPED (when K8s deployment scaled to 0)
 *   STOPPED -> HEALTHY (when K8s deployment scaled up)
 *
 * Pause operation (user-initiated scale to 0):
 *   (HEALTHY | UNHEALTHY | STOPPED) -> PENDING -> LAUNCHING -> STOPPED
 *
 * Resume operation (restore from paused):
 *   STOPPED -> PENDING -> LAUNCHING -> DEPLOYED -> (HEALTHY | STOPPED)
 *
 * Termination:
 *   (any state) -> TERMINATING -> TERMINATED
 *   TERMINATED -> PREPARING (only when workspace undeleted/unarchived)
 *
 * Unhealthy termination (automatic):
 *   UNHEALTHY -> FAILED (after extended unhealthy period, auto-terminated)
 *
 * Unexpected K8s deletion (automatic recovery):
 *   (HEALTHY | UNHEALTHY | STOPPED) -> PENDING (triggers automatic redeployment)
 *
 * Note: Multiple operations use the same public API states:
 * - PENDING is used for: initial create, updates, pause requests, and resume requests
 * - LAUNCHING is used for: deployment/update execution, pause execution, and resume execution
 * - STOPPED is used for: K8s-detected scale-to-0 and paused deployments
 * - FAILED is used for: preparation/launch failures, unhealthy termination, and internal redeployment cleanup
 * Use the updates_allowed field and message to distinguish the specific operation.
 *
 * @generated from enum ai.h2o.mlops.deployer.v2.DeploymentStatus.DeploymentState
 */
export enum DeploymentStatus_DeploymentState {
/**
 * Unknown status
 *
 * @generated from enum value: DEPLOYMENT_STATE_UNSPECIFIED = 0;
 */
DEPLOYMENT_STATE_UNSPECIFIED = "DEPLOYMENT_STATE_UNSPECIFIED",

/**
 * Preparing the Deployment for launch
 * E.g., building assets.
 *
 * @generated from enum value: PREPARING = 1;
 */
PREPARING = "PREPARING",

/**
 * Deployment is being applied to Kubernetes.
 * Executing Kubernetes API calls to create or update the deployment.
 *
 * @generated from enum value: LAUNCHING = 2;
 */
LAUNCHING = "LAUNCHING",

/**
 * Deployment failed during preparation or launch.
 *
 * @generated from enum value: FAILED = 3;
 */
FAILED = "FAILED",

/**
 * Deployment is alive and healthy.
 *
 * @generated from enum value: HEALTHY = 4;
 */
HEALTHY = "HEALTHY",

/**
 * Health issues detected with the launched Deployment.
 *
 * @generated from enum value: UNHEALTHY = 5;
 */
UNHEALTHY = "UNHEALTHY",

/**
 * Deployment is terminating.
 * I.e., target environment resources are being brought down.
 *
 * @generated from enum value: TERMINATING = 6;
 */
TERMINATING = "TERMINATING",

/**
 * Deployment created and awaiting processing.
 *
 * @generated from enum value: PENDING = 7;
 */
PENDING = "PENDING",

/**
 * Deployment is terminated.
 *
 * @generated from enum value: TERMINATED = 8;
 */
TERMINATED = "TERMINATED",

/**
 * Stopped (when deployments is scaled down)
 *
 * @generated from enum value: STOPPED = 9;
 */
STOPPED = "STOPPED",

/**
 * Deployment has been applied to Kubernetes and is waiting for health checks.
 * The deployment will transition to HEALTHY once all pods are healthy, or FAILED if it times out.
 *
 * @generated from enum value: DEPLOYED = 10;
 */
DEPLOYED = "DEPLOYED",
}
export const deploymentStatusName = getNameParser<'workspace' | 'deployment'>("workspaces/{workspace}/deployments/{deployment}/status");
